import React from 'react';
const styles = {width: '99vw', height: '88vh'};

function Actividad() {
    return (
        <iframe 
        title='Caracterizacion'
        src="https://geologiaconce.maps.arcgis.com/apps/dashboards/7cfc65de000c44afbdaaa45672b34cf1"
        style={styles}>
        </iframe>
    )
}

export default Actividad
